import React from 'react';
import PropTypes, { object } from 'prop-types';

import { ComposedAL } from 'components/common/charts/charts';

import { createConfig } from 'components/common/charts/ComposedAL/helpers/helpers';

const Chart = ({ data }) => {
  const trendKey = 'score';
  const notAreaArr = ['date', 'responders', trendKey]; //not area keys

  const config = {
    title: 'Responders and Score Over Time',
    trendKey: trendKey,
    config: createConfig(data, notAreaArr, false)
  };

  config.config.push({
    name: 'score',
    value: true,
    color: '#536283',
    type: 'line'
  });

  return <ComposedAL config={config} data={data} />;
};

Chart.propTypes = {
  data: PropTypes.arrayOf(object)
};

export default Chart;
